import { render, staticRenderFns } from "./ProposalEdit.vue?vue&type=template&id=044928f6&"
import script from "./ProposalEdit.vue?vue&type=script&lang=js&"
export * from "./ProposalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports